<template>
   <footer class="footer-container">
     <div class="left-content">
       <!-- 导航菜单 -->
       <div class="navigation-menu">
         <div 
           class="menu-column"
           v-for="(column, colIndex) in menuColumns" 
           :key="colIndex"
         >
           <h3>{{ column.title }}</h3>
           <ul>
             <li 
               v-for="(item, itemIndex) in column.items" 
               :key="itemIndex"
               class="menu-item"
             >
               <a :href="item.link">{{ item.text }}</a>
             </li>
           </ul>
         </div>
       </div>
 
       <!-- 公司地址信息 -->
       <div class="company-address">
         <p class="address-line">{{ $t("footer.headquarterAddress") }}</p>
         <p class="address-line">{{ $t("footer.branchAddress") }}</p>
       </div>
     </div>
 
     <!-- 右侧内容 -->
     <div class="right-content">
       <div class="qr-group">
         <div class="qr-item">
           <img src="@/assets/footer/lozky.jpg" alt="QR Code">
           <p class="qr-caption">{{ $t("footer.followOfficialAccount") }}</p>
         </div>
       </div>
     </div>
   </footer>
 </template>
 
 <script>
 export default {
   name: 'FooterComponent',
   data() {
     return {
       menuColumns: [
         {
           title: this.$t('nav.products'),
           items: [
             { text: this.$t('nav.fanSeries'), link: '#' },
             { text: this.$t('nav.lampSeries'), link: '#' },
             { text: this.$t('nav.nightLight'), link: '#' },
             { text: this.$t('nav.mosquitoLamp'), link: '#' },
             { text: this.$t('nav.humidifier'), link: '#' },
             { text: this.$t('nav.heater'), link: '#' },
             { text: this.$t('nav.handWarmer'), link: '#' },
             { text: this.$t('nav.ipSeries'), link: '#' }
           ]
         },
         {
           title: this.$t('nav.about'),
           items: [
             { text: this.$t('nav.brandIntro'), link: '#' },
             { text: this.$t('nav.history'), link: '#' },
             { text: this.$t('nav.video'), link: '#' },
             { text: this.$t('nav.honors'), link: '#' }
           ]
         },
         {
           title: this.$t('nav.news'),
           items: [
             { text: this.$t('nav.exhibition'), link: '#' },
             { text: this.$t('nav.companyNews'), link: '#' }
           ]
         },
         {
           title: this.$t('nav.service'),
           items: [
             { text: this.$t('nav.contactUs'), link: '#' }
           ]
         },
         {
           title: this.$t('nav.join'),
           items: [
             { text: this.$t('nav.socialRecruitment'), link: '#' },
             { text: this.$t('nav.campusRecruitment'), link: '#' },
             { text: this.$t('nav.internalReferral'), link: '#' }
           ]
         },
         {
           title: this.$t('nav.find'),
           items: [
             { text: '1688', link: 'https://lozky.1688.com/?spm=a360g.21633289.0.0.25b5410cfELvcy' },
             { text: '拼多多', link: 'https://mobile.yangkeduo.com/mall_page.html?mall_id=938939512&msn=jju6xnzeyustvktqchoc6wl6ni_axbuy&_sop_rcto' }
           ]
         }
       ]
     };
   }
 };
 </script>
 
 <style scoped>
 .footer-container {
   display: flex;
   justify-content: space-between;
   padding: 10px 64px;
   border-top: 1px solid #e5e5e5;
   height: 30vh;
 }
 
 .left-content {
   flex: 1;
   max-width: 60%;
   padding-left: calc((40% - 150px - 64px) / 2);
 }
 
 .navigation-menu {
   display: grid;
   grid-template-columns: repeat(6, 1fr);
   gap: 24px;
 }
 
 .menu-column h3 {
   font-size: 1vw;
   color: #1d1d1f;
   margin-bottom: 18px;
   font-weight: 600;
   letter-spacing: 0.5px;
 }
 
 .menu-column ul {
   list-style: none; /* 移除<li>的默认样式 */
   padding: 0;
   margin: 0;
 }
 
 .menu-item {
   margin-bottom: 8px; /* 调整间距更紧凑 */
   line-height: 1.4;
 }
 
 .menu-item a {
   font-size: 0.7vw; /* 增大字体 */
   color: #424245;
   text-decoration: none;
   transition: color 0.2s;
 }
 
 .menu-item a:hover {
   color: #06c;
 }
 
 .company-address {
   padding-top: 10px;
 }
 
 .address-line {
   font-size: 0.7vw;
   color: #86868b;
   margin: 8px 0;
   line-height: 1.6;
 }
 
 .right-content {
   padding-top: 30px;
   flex: 0 0 40%;
  
 }
 
 .qr-group {
   display: flex;
   flex-direction: column;
   gap: 24px;
 }
 
 .qr-item {
   text-align: center;
 }
 
 .qr-item img {
   width: 150px;
   height: 150px;
   margin-bottom: 12px;
   border-radius: 8px;
   box-shadow: 0 2px 8px rgba(0,0,0,0.1);
 }
 
 .qr-caption {
   font-size: 0.7vw;
   color: #1d1d1f;
   margin: 0;
 }
 
 /* 响应式适配 */
 @media (max-width: 1280px) {
   .footer-container {
     padding: 40px 48px;
   }
 
   .navigation-menu {
     gap: 24px;
   }
 }
 
 @media (max-width: 1024px) {
   .footer-container {
     flex-direction: column;
     padding: 40px;
   }
 
   .left-content {
     max-width: 100%;
     margin-bottom: 40px;
   }
 
   .right-content {
     padding-left: 0;
     border-left: none;
     border-top: 1px solid #e5e5e5;
     padding-top: 40px;
   }
 
   .qr-group {
     flex-direction: row;
     justify-content: center;
     gap: 48px;
   }
 }
 
 @media (max-width: 768px) {
   .navigation-menu {
     grid-template-columns: repeat(3, 1fr);
     gap: 32px 24px;
   }
 
   .footer-container {
     padding: 32px 24px;
   }
 }
 
 @media (max-width: 480px) {
   .navigation-menu {
     grid-template-columns: repeat(2, 1fr);
   }
 
   .qr-group {
     flex-direction: column;
     gap: 24px;
   }
 }
 </style>